/**
 * SpreadsheetNote Component
 *
 * @component
 * @description This component represents a spreadsheet note and provides an interface to view, edit, and delete it.
 * It displays the note's content, author, creation date, and provides actions to edit or delete the note.
 * This is a placeholder component - actual implementation will be handled separately.
 *
 * @param {SpreadsheetNoteItemProps} props - The properties and event handlers required by the component.
 * @returns {JSX.Element} - A JSX element representing the SpreadsheetNote component.
 */

import { useMemo } from 'react';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { SpreadsheetNoteItemProps } from '../types';

const SpreadsheetNote = ({ note, workbook, onChange, parentContainerHeight, isAttributeMapperEnabled, cells }: SpreadsheetNoteItemProps) => {

  const columnWidths = useMemo(() => {
    const defaultWidth = 175;
    const contentWidths = Object.values(note.initialObj?.content?.column_data ?? {}).map(column => column.column_width || defaultWidth);
    contentWidths.push(defaultWidth); // For row header
    if (isAttributeMapperEnabled) {
      contentWidths.unshift(defaultWidth)
    }
    return contentWidths;
  },[note, isAttributeMapperEnabled])

  const virtualization = useMemo(() => ({
    rowHeight: 30,
    rowOverscanCount: 6,
    height: parentContainerHeight,
    width: 1600,
    columnWidths,
    columnOverscanCount: 4,
  }), [parentContainerHeight, columnWidths]);

    
  return (
    <div>
      {note.cells && cells
                && <ScalarSpreadsheet onChange={onChange} sheet={note} {...note} workbook={workbook} showToolbar virtualization={virtualization} disablePerfectScrollbar/>
      }
    </div>
  );
};

export default SpreadsheetNote;